import { useEffect, useRef } from "react";
import moment from "moment";
import {
  AerialActivityInit,
  ApiCraneInit,
  ShipCrossInit,
  AerialPhotoInit,
} from "../Api";
import Constant from "../constants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const addKeyValue = (obj, key1, key2, value1, value2) => {
  obj[key1] = value1;
  obj[key2] = value2;
  return obj;
}

export const useRefScrollTo = (scrollProps) => {
  const scrollToTop = useRef(null);
  useEffect(() => {
    scrollToTop.current &&
      scrollToTop.current.scrollIntoView({ ...scrollProps });
  });
  return scrollToTop;
};

export const monthDifference = (date) => {
  return Math.ceil(
    moment(new Date(date)).diff(moment(new Date()), "months", true)
  );
};

export const checkWeekDay = (date) => {
  return moment(new Date(date)).isoWeekday();
};

export const operationTime = (time) => {
  const format = "hh:mm:ss";
  const isTime = moment(time, format);
  const beforeTime = moment("07:00:00", format);
  const afterTime = moment("19:00:00", format);
  return isTime.isBetween(beforeTime, afterTime);
};

export const checkValidWeekDay = (date) => {
  const days = [1, 2, 3, 4, 5, 6];
  const exactDay = checkWeekDay(date);
  const isValid = days.includes(exactDay);
  return isValid;
};

export const isValidDate = (d) => d instanceof Date && !isNaN(d);

export const editAerialActivity = (data = {}) => {

  const dataObj = {
    applicationType: data?.applicationType ?? 4,
    aerialActivity: data?.aerialActivity ?? null,
    referenceNumber: data?.referenceNumber ?? null,
    nricPassport: data?.nricPassport ?? null,
    fullName: data?.fullName ?? null,
    salutation: data?.salutation ?? null,
    primaryContactMode: data?.primaryContactMode ?? null,
    mobileNumber: data?.mobileNumber ?? null,
    mobileNumberCountryCode: data?.mobileNumberCountryCode ?? null,
    officeNumber: data?.officeNumber ?? null,
    officeNumberCountryCode: data?.officeNumberCountryCode ?? null,
    homeNumber: data?.homeNumber ?? null,
    homeNumberCountryCode: data?.homeNumberCountryCode ?? null,
    faxNumber: data?.faxNumber ?? null,
    faxNumberCountryCode: data?.faxNumberCountryCode ?? null,
    companyName: data?.companyName ?? null,
    telephoneNumber: data?.telephoneNumber ?? null,
    email: data?.email ?? null,
    activityType: data?.activityType ?? null,
    estimatedDurationMin: data?.aaFireworks?.estimatedDurationMin ?? null,
    numberOfUnits:
      data?.aaFireworks?.numberOfUnits ??
      data?.aaLasersLights?.numberOfUnits ??
      null,
    dangerRadiusMetres: data?.aaFireworks?.dangerRadiusMetres ?? null,
    maxDangerHeightMetres: data?.aaFireworks?.maxDangerHeightMetres ?? null,
    numberOfBalloons: data.aaBalloonHoisting?.numberOfBalloons
      ? data?.aaBalloonHoisting?.numberOfBalloons ?? null
      : data?.aaBalloonRelease?.numberOfBalloons ?? null,
    maxHoistedHeightFeet: data?.aaBalloonHoisting?.maxHoistedHeightFeet ?? null,
    maxBalloonDimensionMetres:
      data?.aaBalloonHoisting?.maxBalloonDimensionMetres ?? null,
    dimensionWeightKg: data?.aaBalloonHoisting?.dimensionWeightKg ?? null,
    numberOfKites: data?.aaKiteParasailing?.numberOfKites ?? null,
    maxHeightFeet: data?.aaKiteParasailing?.maxHeightFeet ?? null,
    dimensionLengthMetres:
      data?.aaKiteParasailing?.dimensionLengthMetres ?? null,
    dimensionBreadthMetres:
      data?.aaKiteParasailing?.dimensionBreadthMetres ?? null,
    laserTypeSpecs: data?.aaLasersLights?.laserTypeSpecs ?? null,
    // numberOfUnits: data?.aaLasersLights?.numberOfUnits ?? null,
    maxPowerOutput: data?.aaLasersLights?.maxPowerOutput ?? null,
    dangerHeight: data?.aaLasersLights?.dangerHeight ?? null,
    dangerHeightInstallation:
      data?.aaLasersLights?.dangerHeightInstallation ?? null,
    maxSizeCm:
      data?.aaBalloonRelease?.maxSizeCm ??
      data?.aaSkyLantern?.maxSizeCm ??
      null,
    numberOfLanterns: data?.aaSkyLantern?.numberOfLanterns ?? null,
    // maxSizeCm: data?.aaSkyLantern?.maxSizeCm ?? null,
    venueDetails: data?.venueDetails ?? null,
    purpose: data?.purpose ?? null,
    activityDays: data?.activityDays ?? null,
    primarySafetyPersonnelName: data?.primarySafetyPersonnelName ?? null,
    primarySafetyPersonnelTelephoneNumber:
      data?.primarySafetyPersonnelTelephoneNumber ?? null,
    secondarySafetyPersonnelName: data?.secondarySafetyPersonnelName ?? null,
    primarySafetyPersonnelTelephoneCountryCode: data?.primarySafetyPersonnelTelephoneCountryCode,
    secondarySafetyPersonnelTelephoneCountryCode: data?.secondarySafetyPersonnelTelephoneCountryCode,
    secondarySafetyPersonnelTelephoneNumber:
      data?.secondarySafetyPersonnelTelephoneNumber ?? null,
    safetyMeasures: data?.safetyMeasures ?? null,
    remarks: data?.remarks ?? null,
    status: data?.status ?? null,
    mapData: data?.mapData ?? null,
    document: data?.documents ?? null,
    draftDocuments: data?.draftDocuments ?? [],
    applicationHistory: data?.applicationHistory ?? null,
    mapSnapshot: data?.mapSnapshot ?? null,
    fileReferenceNumber: data?.fileReferenceNumber ?? null,
  };
  return dataObj;
};

export const aerialResponse = (data = {}) => {

  const dataObj = {
    applicationType: 1,
    referenceNumber: data?.referenceNumber ?? null,
    nricPassport: data?.nricPassport ?? null,
    fullName: data?.fullName ?? null,
    salutation: data?.salutation ?? null,
    primaryContactMode: data?.primaryContactMode ?? null,
    mobileNumber: data?.mobileNumber ?? null,
    mobileNumberCountryCode: data?.mobileNumberCountryCode ?? null,
    officeNumber: data?.officeNumber ?? null,
    officeNumberCountryCode: data?.officeNumberCountryCode ?? null,
    homeNumber: data?.homeNumber ?? null,
    homeNumberCountryCode: data?.homeNumberCountryCode ?? null,
    faxNumber: data?.faxNumber ?? null,
    faxNumberCountryCode: data?.faxNumberCountryCode ?? null,
    companyName: data?.companyName ?? null,
    telephoneNumber: data?.telephoneNumber ?? null,
    email: data?.email ?? null,
    typeOfFlight: data?.aircraftType ?? null,
    maxHeightFeet: data?.apCaptiveBalloon?.maxHeightFeet ?? null,
    dimWeightKg:
      data?.apCaptiveBalloon?.dimWeightKg ??
      data?.apBlimpAirship?.dimWeightKg ??
      null,
    dimLengthMetres:
      data?.apCaptiveBalloon?.dimLengthMetres ??
      data?.apBlimpAirship?.dimLengthMetres ??
      null,
    // dimWeightKg: data?.apBlimpAirship?.dimWeightKg ?? null,
    // dimLengthMetres: data?.apBlimpAirship?.dimLengthMetres ?? null,
    dimBreadthMetres: data?.apBlimpAirship?.dimBreadthMetres ?? null,
    dimMaxAltitudeFt: data?.apBlimpAirship?.dimMaxAltitudeFt ?? null,
    operatorCompany: data?.apHelicopter?.operatorCompany ?? null,
    postalCode: data?.apHelicopter?.postalCode ?? null,
    blockNumber: data?.apHelicopter?.blockNumber ?? null,
    streetName: data?.apHelicopter?.streetName ?? null,
    level: data?.apHelicopter?.level ?? null,
    unitNumber: data?.apHelicopter?.unitNumber ?? null,
    buildingName: data?.apHelicopter?.buildingName ?? null,
    aircraftType: data?.apHelicopter?.aircraftType ?? null,
    aircraftCallsign: data?.apHelicopter?.aircraftCallsign,
    minOperatingAltitudeFeet:
      data?.apHelicopter?.minOperatingAltitudeFeet ?? null,
    maxOperatingAltitudeFeet:
      data?.apHelicopter?.maxOperatingAltitudeFeet ?? null,
    flyOverCityLowHeight: data?.apHelicopter?.flyOverCityLowHeight
      ? "Yes"
      : "No",
    flyOverAssemblyEvent: data?.apHelicopter?.flyOverAssemblyEvent
      ? "Yes"
      : "No",
    purpose: data?.purpose ?? null,
    activityDays: data?.activityDays ?? null,
    primarySafetyPersonnelName: data?.primarySafetyPersonnelName ?? null,
    primarySafetyPersonnelTelephoneNumber:
      data?.primarySafetyPersonnelTelephoneNumber ?? null,
    primarySafetyPersonnelTelephoneCountryCode: data?.primarySafetyPersonnelTelephoneCountryCode,
    secondarySafetyPersonnelTelephoneCountryCode: data?.secondarySafetyPersonnelTelephoneCountryCode,
    secondarySafetyPersonnelName: data?.secondarySafetyPersonnelName ?? null,
    secondarySafetyPersonnelTelephoneNumber:
      data?.secondarySafetyPersonnelTelephoneNumber ?? null,
    safetyMeasures: data?.safetyMeasures ?? null,
    remarks: data?.remarks ?? null,
    status: data?.status ?? null,
    mapData: data?.mapData ?? null,
    document: data?.documents ?? null,
    draftDocuments: data?.draftDocuments ?? [],
    applicationHistory: data?.applicationHistory ?? null,
    mapSnapshot: data?.mapSnapshot ?? null,
    fileReferenceNumber: data?.fileReferenceNumber ?? null,
  };
  return dataObj;
};

export const defaultAerialResponse = {
  ...aerialResponse(null),
  flyOverCityLowHeight: null,
  flyOverAssemblyEvent: null,
};

export const getCraneFormData = (data = {}) => {
  const dataObj = {
    applicationType: 2,
    referenceNumber: data?.referenceNumber ?? null,
    nricPassport: data?.nricPassport ?? null,
    fullName: data?.fullName ?? null,
    salutation: data?.salutation ?? null,
    primaryContactMode: data?.primaryContactMode ?? null,
    mobileNumber: data?.mobileNumber ?? null,
    mobileNumberCountryCode: data?.mobileNumberCountryCode ?? null,
    officeNumber: data?.officeNumber ?? null,
    officeNumberCountryCode: data?.officeNumberCountryCode ?? null,
    homeNumber: data?.homeNumber ?? null,
    homeNumberCountryCode: data?.homeNumberCountryCode ?? null,
    faxNumber: data?.faxNumber ?? null,
    faxNumberCountryCode: data?.faxNumberCountryCode ?? null,
    companyName: data?.companyName ?? null,
    telephoneNumber: data?.telephoneNumber ?? null,
    email: data?.email ?? null,
    craneMachineryList: data?.craneMachineryList ?? null,
    devCompanyName: data?.devCompanyName ?? null,
    devProjectManagerName: data?.devProjectManagerName ?? null,
    devTelephoneNumber: data?.devTelephoneNumber ?? null,
    devEmailAddress: data?.devEmailAddress ?? null,
    contractorCompanyName: data?.contractorCompanyName ?? null,
    contractorProjectManagerName: data?.contractorProjectManagerName ?? null,
    contractorTelephoneNumber: data?.contractorTelephoneNumber ?? null,
    contractorEmailAddress: data?.contractorEmailAddress ?? null,
    supplierCompanyName: data?.supplierCompanyName ?? null,
    supplierProjectManagerName: data?.supplierProjectManagerName ?? null,
    supplierTelephoneNumber: data?.supplierTelephoneNumber ?? null,
    supplierEmailAddress: data?.supplierEmailAddress ?? null,
    safetyCompanyName: data?.safetyCompanyName ?? null,
    safetyProjectManagerName: data?.safetyProjectManagerName ?? null,
    safetyTelephoneNumber: data?.safetyTelephoneNumber ?? null,
    safetyEmailAddress: data?.safetyEmailAddress ?? null,
    projectTitle: data?.projectTitle ?? null,
    siteAddressType: data?.siteAddressType ?? null,
    sitePostalCode: data?.sitePostalCode ?? null,
    siteBlockNumber: data?.siteBlockNumber ?? null,
    siteStreetName: data?.siteStreetName ?? null,
    siteLevel: data?.siteLevel ?? null,
    siteUnitNumber: data?.siteUnitNumber ?? null,
    siteBuildingName: data?.siteBuildingName ?? null,
    siteNonStandardAddress: data?.siteNonStandardAddress ?? null,
    landLotNo: data?.landLotNo ?? null,
    expectedCompletionDate: data?.expectedCompletionDate ?? "",
    approvedDevelopmentHeightMetres:
      data?.approvedDevelopmentHeightMetres ?? null,
    siteGroundElevationMetres: data?.siteGroundElevationMetres ?? null,
    siteInAirport: data?.siteInAirport ? "Yes" : "No",
    airportMachineryDeployedAdhoc: data?.airportMachineryDeployedAdhoc
      ? "Yes"
      : "No",
    airportSiteInCriticalAreas: data?.airportSiteInCriticalAreas ? "Yes" : "No",
    airportWorkDuringRunwayClosure: data?.airportWorkDuringRunwayClosure
      ? "Yes"
      : "No",
    airportStockpileExists: data?.airportStockpileExists ? "Yes" : "No",
    stockPileHeightMetres: data?.stockPileHeightMetres ?? null,
    stockPileLocLatitude: data?.stockPileLocLatitude ?? null,
    stockPileLocLongitude: data?.stockPileLocLongitude ?? null,
    airsideSafetyMeasures: data?.airsideSafetyMeasures ?? null,
    machineryPeriodUseFrom: data?.machineryPeriodUseFrom ?? "",
    machineryPeriodUseTo: data?.machineryPeriodUseTo ?? "",
    remarks: data?.remarks ?? null,
    status: data?.status === "MORE_INFO_NEEDED" ? "MORE_INFO_NEEDED" : "DRAFT",
    fileReferenceNumber: data?.fileReferenceNumber ?? null,
    mapData: data?.mapData ?? null,
    highestWorkingHeightMeters: data?.highestWorkingHeightMeters ?? null,
    locationDescription: data?.locationDescription ?? null,
    document: data?.documents ?? null,
    draftDocuments: data?.draftDocuments ?? [],
    applicationHistory: data?.applicationHistory ?? null,
    mapSnapshot: data?.mapSnapshot ?? null,
    devTelephoneCountryCode: data?.devTelephoneCountryCode ?? null,
    contractorTelephoneCountryCode: data?.contractorTelephoneCountryCode ?? null,
    supplierTelephoneCountryCode: data?.supplierTelephoneCountryCode ?? null,
    safetyTelephoneCountryCode: data?.safetyTelephoneCountryCode ?? null,
    applicantRole: data?.applicantRole ?? null,
    applicantCompanyName: data?.applicantCompanyName ?? null,
  };
  return dataObj;
};

export const defaultCraneForm = {
  ...getCraneFormData({}),
  siteInAirport: null,
  airportMachineryDeployedAdhoc: null,
  airportSiteInCriticalAreas: null,
  airportWorkDuringRunwayClosure: null,
  airportStockpileExists: null,
  siteAddressType: null,
  siteAddressTypeFlag: "NSTD"
};

export const shipCrossingForm = (responseData = {}) => {
  const dataObj = {
    ...responseData,
    applicationType: 3,
    referenceNumber: responseData?.referenceNumber ?? null,
    nricPassport: responseData?.nricPassport ?? null,
    fullName: responseData?.fullName ?? null,
    salutation: responseData?.salutation ?? null,
    primaryContactMode: responseData?.primaryContactMode ?? null,
    mobileNumber: responseData?.mobileNumber ?? null,
    mobileNumberCountryCode: responseData?.mobileNumberCountryCode ?? null,
    officeNumber: responseData?.officeNumber ?? null,
    officeNumberCountryCode: responseData?.officeNumberCountryCode ?? null,
    homeNumber: responseData?.homeNumber ?? null,
    homeNumberCountryCode: responseData?.homeNumberCountryCode ?? null,
    faxNumber: responseData?.faxNumber ?? null,
    faxNumberCountryCode: responseData?.faxNumberCountryCode ?? null,
    companyName: responseData?.companyName ?? null,
    telephoneNumber: responseData?.telephoneNumber ?? null,
    email: responseData?.email ?? null,
    shipReportingPointDetails: responseData?.shipReportingPointDetails ?? null,
    vesselMovementDate: responseData?.vesselMovementDate ?? null,
    vesselName: responseData?.vesselName ?? null,
    callsign: responseData?.callsign ?? null,
    heightMetres: responseData?.heightMetres ?? null,
    originPort: responseData?.originPort ?? null,
    originPoint: responseData?.originPoint ?? null,
    fileReferenceNumber: responseData?.fileReferenceNumber ?? null,
    finalDestination: responseData?.finalDestination ?? null,
    primarySafetyPersonnelName:
      responseData?.primarySafetyPersonnelName ?? null,
    primarySafetyPersonnelTelephoneNumber:
      responseData?.primarySafetyPersonnelTelephoneNumber ?? null,
    primarySafetyPersonnelTelephoneCountryCode: responseData?.primarySafetyPersonnelTelephoneCountryCode,
    primarySafetyPersonnelEmail:
      responseData?.primarySafetyPersonnelEmail ?? null,
    secondarySafetyPersonnelName:
      responseData?.secondarySafetyPersonnelName ?? null,
    secondarySafetyPersonnelTelephoneNumber:
      responseData?.secondarySafetyPersonnelTelephoneNumber ?? null,
    secondarySafetyPersonnelTelephoneCountryCode: responseData?.secondarySafetyPersonnelTelephoneCountryCode,
    secondarySafetyPersonnelEmail:
      responseData?.secondarySafetyPersonnelEmail ?? null,
    safetyMeasures: responseData?.safetyMeasures ?? null,
    remarks: responseData?.remarks ?? null,
    status: responseData?.status === "MORE_INFO_NEEDED" ? "MORE_INFO_NEEDED" : "DRAFT",
    //mapData: { geoJson: responseData?.mapData ?? [] },
    mapData: responseData?.mapData ?? null,
    draftDocuments: responseData?.draftDocuments ?? null,
    applicationHistory: responseData?.applicationHistory ?? null,
    mapSnapshot: responseData?.mapSnapshot ?? null
  };
  return dataObj;
};

export const fetchApplicationTypeApi = (type) => {
  switch (type) {
    case 1:
      return AerialPhotoInit;
    case 2:
      return ApiCraneInit;
    case 3:
      return ShipCrossInit;
    case 4:
      return AerialActivityInit;
  }
};

export const statusFn = (status = "") => {
  switch (status) {
    case "PENDING_REGISTRATION":
      return Constant.PENDING_REGISTRATION_MSG
    case "SUBMITTED":
      return Constant.SUBMITTED_MSG
    case "MORE_INFO_NEEDED":
      return Constant.MORE_INFO_NEEDED_MSG
    case "REJECTED":
      return Constant.REJECTED_MSG
    case "DISABLED":
      return Constant.DISABLED_MSG
    default:
      return Constant.GENERIC_MSG
  }
}

export const validateNRIC = (str) => {
  if (str && str.length !== 9)
    return false;

  str = str.toUpperCase();

  let i,
    icArray = [];
  for (i = 0; i < 9; i++) {
    icArray[i] = str.charAt(i);
  }

  icArray[1] = parseInt(icArray[1], 10) * 2;
  icArray[2] = parseInt(icArray[2], 10) * 7;
  icArray[3] = parseInt(icArray[3], 10) * 6;
  icArray[4] = parseInt(icArray[4], 10) * 5;
  icArray[5] = parseInt(icArray[5], 10) * 4;
  icArray[6] = parseInt(icArray[6], 10) * 3;
  icArray[7] = parseInt(icArray[7], 10) * 2;

  let weight = 0;
  for (i = 1; i < 8; i++) {
    weight += icArray[i];
  }

  let offset = (icArray[0] === "T" || icArray[0] === "G") ? 4 : 0;
  let temp = (offset + weight) % 11;

  let st = ["J", "Z", "I", "H", "G", "F", "E", "D", "C", "B", "A"];
  let fg = ["X", "W", "U", "T", "R", "Q", "P", "N", "M", "L", "K"];

  let theAlpha;
  if (icArray[0] === "S" || icArray[0] === "T") { theAlpha = st[temp]; }
  else if (icArray[0] === "F" || icArray[0] === "G" || icArray[0] === "M") { theAlpha = fg[temp]; }

  return (icArray[8] === theAlpha);
}

export const myInfo = {
  identificationNumber: null,
  fullName: null,
  citizenship: null,
  mobileNumberCountryCode: "65",
  mobileNumber: null,
  emailAddress: null,
  addressLocalBlock: null,
  addressLocalStreetName: null,
  addressLocalLevel: null,
  addressLocalUnitNumber: null,
  addressLocalBuildingName: null,
  addressLocalPostalCode: null
};

export const profileReqParams = {
  "recordId": null,
  "salutation": null,
  "fullName": null,
  "isNric": false,
  "isFin": false,
  "identificationNumber": null,
  "passportIssueCountry": null,
  "primaryContactMode": null,
  "homeNumberCountryCode": null,
  "officeNumberCountryCode": null,
  "mobileNumberCountryCode": null,
  "faxNumberCountryCode": null,
  "homeNumber": null,
  "mobileNumber": null,
  "officeNumber": null,
  "faxNumber": null,
  "citizenship": null,
  "designation": null,
  "emailAddress": null,
  "alternativeEmail": null,
  "isAddressLocal": false,
  "addressLocalAddressType": null,
  "addressLocalTypeOfPremises": null,
  "addressLocalPostalCode": null,
  "addressLocalBlock": null,
  "addressLocalStreetName": null,
  "addressLocalLevel": null,
  "addressLocalUnitNumber": null,
  "addressLocalBuildingName": null,
  "addressForeignerTypeOfPremises": null,
  "addressForeignerTypeOfPremisesOthers": null,
  "mailingAddressLocalTypeOfPremisesOthers": null,
  "mailingAddressForeignerTypeOfPremisesOthers": null,
  "addressForeignerAddressLine1": null,
  "addressForeignerAddressLine2": null,
  "addressForeignerAddressLine3": null,
  "addressForeignerAddressLine4": null,
  "addressForeignerAddressLine5": null,
  "addressForeignerCity": null,
  "addressForeignerState": null,
  "addressForeignerPostalCode": null,
  "addressForeignerCountry": null,
  "isMailingAddressLocal": false,
  "mailingAddressLocalAddressType": null,
  "mailingAddressLocalTypeOfPremises": null,
  "mailingAddressLocalPostalCode": null,
  "mailingAddressLocalBlock": null,
  "mailingAddressLocalStreetName": null,
  "mailingAddressLocalLevel": null,
  "mailingAddressLocalUnitNumber": null,
  "mailingAddressLocalBuildingName": null,
  "mailingAddressForeignerTypeOfPremises": null,
  "mailingAddressForeignerAddressLine1": null,
  "mailingAddressForeignerAddressLine2": null,
  "mailingAddressForeignerAddressLine3": null,
  "mailingAddressForeignerAddressLine4": null,
  "mailingAddressForeignerAddressLine5": null,
  "mailingAddressForeignerCity": null,
  "mailingAddressForeignerState": null,
  "mailingAddressForeignerPostalCode": null,
  "mailingAddressForeignerCountry": null,
  "document1Name": null,
  "document2Name": null,
  "status": null,
  "sameAsForeignAddress": null,
  "sameAsLocalAddress": null
};

export const validatePhoneNumber = (
  inputNumber,
  country,
  isDirty,
  phoneLength
) => {

  if (isDirty) {
    if (
      inputNumber &&
      inputNumber?.replace(country.dialCode, '')?.trim() === ''
    ) {

      return false;
    } else if (inputNumber?.replace(country.dialCode, '')?.trim().length < phoneLength) {

      return false;
    }

    return true;
  }

  return false;
};

export function isFilenameLengthValid(filename) {
  const MAX_FILENAME_LENGTH = 150;
  if (filename?.length <= MAX_FILENAME_LENGTH) {
    return true;
  }
  return false;
}


const supportDocumentsExtensions = ['pdf', 'png', 'jpg', 'jpeg'];

export var fileValidation = {
  isValid: true,
  message: "",
  name: "",
  extension: ""
};

const fileNameDisallowedChars = ['!', '@', '#', '$', '%',
  '^', '&', '*', '(', ')', '+', '=', '{', '}', '[', ']',
  '|', '\\', ';', ':', "'", '"', ',', '<', '>', '/', '?', '`', '~'];



export function isFileNameHasSpecialChars(fileName) {

  const lastDotIndex = fileName.lastIndexOf('.');
  const name = fileName.substring(0, lastDotIndex);
  let outFlg = false;

  for (let splChar of fileNameDisallowedChars) {
    if (name.includes(splChar)) {
      outFlg = true;
      return true;
    }
  }

  return outFlg;
}

const fileTypeAllowed = ["application/pdf", "image/jpg", "image/jpeg", "image/png", "text/csv"];

export function isFileTypeAllowed(fileType) {
  return (fileTypeAllowed.indexOf(fileType) > -1);
}

export function isValidExtension(filename) {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return false;
  }
  const extension = filename.substring(lastDotIndex + 1).toLowerCase();
  if (!supportDocumentsExtensions.includes(extension)) {
    return false;
  }
  return true;
}

export function isDateGreaterThanXDaysFromNow(inputDate, inputDays) {
  let now = new Date();
  now.setDate(now.getDate() + inputDays);
  return moment(inputDate).format("YYYY-MM-DD") > moment(now).format("YYYY-MM-DD");
}

export function datePlusDays(inputDate, inputDays) {
  if (!inputDate)
    inputDate = new Date();

  inputDate.setDate(inputDate.getDate() + inputDays);
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, '0');
  const day = String(inputDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export const isSmallScreenDevice = () => {
  //console.log("window.innerWidth-->" + window.innerWidth);
  if (window.innerWidth <= 1000) {
    return true;
  }
  return false;
}


export const SsTooltip = (props) => {
  // Add 'id' to the props
  const { message, id } = props;
  return (
    <OverlayTrigger
      trigger="click"
      placement="top"
      rootClose
      overlay={
        // Use the dynamic id here
        <Tooltip id={id || "tooltip-icon"} className="ss-tooltip">
          {message}
        </Tooltip>
      }
    >
      <i
        className="bi bi-info-circle ms-2 ss-tooltip-icon"
        style={{ cursor: 'pointer', color: '#0d6efd' }}
        aria-label="info"
      ></i>
    </OverlayTrigger>
  );
}
export const getPermitFee = (feeList, appType, appSubType) => {

  //For now no fee is applicable for any application type. Hence returning 0.
  return 0;

  // if (!feeList || !Array.isArray(feeList)) return null;

  // try {
  //   for (const element of feeList) {
  //     if (!appSubType && appType && element.applicationType === appType) {
  //       return element.applicationFee;
  //     }
  //     if (appType && appSubType &&
  //         element.applicationType === appType &&
  //         element.applicationSubType === appSubType) {
  //       return element.applicationFee;
  //     }
  //   }
  // } catch (err) {
  //   console.error(err);
  // }
  // return null;
};


export default addKeyValue;